<template>
	<div class=" widthFull fitAvailableHeight pt-5" style="color: black;" ref="privacy">
		<loading v-if="loadingState" />
		<div class="container-fluid">
			<div class="row mb-5 pt-5 center">
				<h3 class="tizaFont bbaWhite center  widthFull"><span style="color: black;">Informativa per il trattamento dei dati personali</span></h3>
			</div>
		</div>
		<div class="container regulationContainer pb-5">

		</div>
	</div>
</template>


<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { USER_REQUEST } from 'actions/user'


export default {
    name: 'privacy',
	data () {
      return {
		loadingState: '',
		userToken: ''
      }
    },
	methods: {
		scrollToTop: function () {
			window.scrollTo(0, 0);
		},
    },
	watch: {

	},
	mounted: function(){
		window.location.replace(process.env.COOKIE )
	},

  }
</script>

<style lang="css" scoped>

	.regulationContainer{
		font-size: 18px;
	}

	.page__title{
		font-size: 18px!important;
		font-weight: 800;
	}

	.navigation {
		position: fixed;
		bottom: 0;
		background: #fffbde;
		color: #8a222f;
		left: 0;
		width: 100%;
		padding: 5px;
		font-size: 22px;
		text-align: center;

	}
	.navItem {
		margin: 10px;
		text-transform: uppercase;
		font-weight: 800;
		cursor: pointer;
		text-decoration: underline;
	}

	@media (min-width: 20px) and (max-width: 767px) {
		.regulationContainer{
			font-size: 14px;
		}
		.col-md-4.text-right{
			text-align: left!important;
		}
		.navigation {
			left: 0;
			width: 100%;
			padding: 8px;
			font-size: 14px;
			text-align: center;
		}


	}

</style>



// WEBPACK FOOTER //
// src/components/cookie/index.vue